<template>
  <div id="bounties">
    <info-box v-bind:description="description"></info-box>
    <header-title
      title="BOUNTIES"
      subtitle="Current top bounties. Gift a sub and claim the bounty!"
    />

    <div class="tiers">
      <section
        v-for="tier in tiers"
        v-bind:key="tier.level"
        class="tier sl-panel"
        v-bind:class="`tier--${tier.variant}`"
      >
        <div class="tier__head">
          <div class="tier__id">
            <span class="tier__name">{{ tier.name }}</span>
            <span class="tier__badge">{{ tier.badge }}</span>
          </div>
          <span class="tier__count">
            {{ tier.rows.length }} {{ tier.rows.length === 1 ? 'hunter' : 'hunters' }}
          </span>
        </div>

        <div class="tier__cols bounty-grid">
          <span>#</span>
          <span>User Name</span>
          <span class="tier__cols-amount">Bounty</span>
          <span></span>
        </div>

        <Bounty
          v-for="(subBounty, index) in tier.rows"
          v-bind:key="subBounty.user_id"
          v-bind:subBounty="subBounty"
          v-bind:tier="tier.level"
          v-bind:rank="index + 1"
          v-bind:btnLabel="tier.btn"
        ></Bounty>
      </section>

      <p v-if="!tiers.length" class="tiers__empty">No bounties on the board right now.</p>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Bounty from './Bounty'

export default {
  name: 'bounties',
  components: {
    Bounty
  },
  async created () {
    await this.refreshSubBounties()
  },
  data () {
    return {
      description: {
        title: 'Bounties',
        text: `You want to get some SwiftBucks, Gift a sub to one of the accounts displayed below and win the bounty, Not subbed? Add SwiftBucks to your bounty by typing !add followed by the amount in chat, if someone gift subs you, they get em`
      }
    }
  },
  computed: Object.assign(mapState(['subBounties']), {
    tiers () {
      return [
        {
          level: 3,
          name: 'TIER 3',
          badge: 'Prestige',
          variant: 'gold',
          btn: 'Gift Tier 3 Sub',
          rows: this.subBounties.sub_bounties_t3 || []
        },
        {
          level: 2,
          name: 'TIER 2',
          badge: 'Elite',
          variant: 'purple',
          btn: 'Gift Tier 2 Sub',
          rows: this.subBounties.sub_bounties_t2 || []
        },
        {
          level: 1,
          name: 'TIER 1',
          badge: 'Open',
          variant: 'plain',
          btn: 'Gift Sub',
          rows: this.subBounties.sub_bounties_t1 || []
        }
      ].filter(tier => tier.rows.length > 0)
    }
  }),
  methods: {
    async refreshSubBounties () {
      this.$store.dispatch('fetchSubBounties', {channelId: '274625', tier: 1})
      this.$store.dispatch('fetchSubBounties', {channelId: '274625', tier: 2})
      this.$store.dispatch('fetchSubBounties', {channelId: '274625', tier: 3})
    }
  }
}
</script>

<style scoped>
.tiers {
  display: flex;
  flex-direction: column;
  gap: 34px;
  margin-top: 12px;
  text-align: left;
}

.tiers__empty {
  text-align: center;
  color: var(--sl-muted);
  font-size: 15px;
}

/* per-tier accent, overridden by the variant classes below */
.tier {
  --tier-accent: #ffffff;
  --tier-border: rgba(255, 255, 255, 0.12);
  --tier-wash: rgba(255, 255, 255, 0.05);
  border-color: var(--tier-border);
}

.tier--gold {
  --tier-accent: var(--sl-gold);
  --tier-border: rgba(242, 193, 78, 0.4);
  --tier-wash: rgba(242, 193, 78, 0.12);
}

.tier--purple {
  --tier-accent: var(--sl-purple-hi);
  --tier-border: rgba(145, 70, 255, 0.4);
  --tier-wash: rgba(145, 70, 255, 0.12);
}

.tier__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 18px 24px;
  background: linear-gradient(90deg, var(--tier-wash), rgba(20, 20, 25, 0.4));
  border-bottom: 1px solid var(--sl-line);
}

.tier__id {
  display: flex;
  align-items: center;
  gap: 14px;
}

.tier__name {
  font-family: var(--sl-font-display);
  font-size: 30px;
  letter-spacing: 1px;
  line-height: 1;
  color: var(--tier-accent);
}

.tier__badge {
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: var(--tier-accent);
  border: 1px solid var(--tier-border);
  padding: 3px 9px;
  border-radius: 20px;
  white-space: nowrap;
}

.tier__count {
  font-size: 13px;
  font-weight: 700;
  color: #85858f;
  white-space: nowrap;
}

.tier__cols {
  padding-top: 11px;
  padding-bottom: 11px;
  background: linear-gradient(90deg, var(--sl-red), #9a1319);
  font-family: var(--sl-font-cond);
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  font-size: 13px;
}

.tier__cols-amount {
  text-align: right;
}

@media (max-width: 760px) {
  .tier__head {
    padding: 14px;
    flex-wrap: wrap;
  }
  .tier__name {
    font-size: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Bounties.vue